import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

export class LinkUser
{
	public usernameToLink: string;
	public password: string;

	public constructor(usernameToLink: string, password: string)
	{
		this.usernameToLink = usernameToLink;
		this.password = password;
	}
}

@Injectable()
export class SharedUserLinkingRepository
{
	private http: HttpClient;

	public constructor(http: HttpClient)
	{
		this.http = http;
	}

	public linkUser(linkUser: LinkUser): Observable<boolean>
	{
		return this.http.post<boolean>("link", linkUser);
	}
}
